export const UPDATE_AUTOMATIC_REPORT_REQUEST = "UPDATE_AUTOMATIC_REPORT_REQUEST";
export const UPDATE_AUTOMATIC_REPORT_SUCCESS = "UPDATE_AUTOMATIC_REPORT_SUCCESS";
export const UPDATE_AUTOMATIC_REPORT_FAILURE = "UPDATE_AUTOMATIC_REPORT_FAILURE";
export const UPDATE_AUTOMATIC_REPORT_RESET = "UPDATE_AUTOMATIC_REPORT_RESET";

export const AUTOMATIC_REPORT_REQUEST = "AUTOMATIC_REPORT_REQUEST";
export const AUTOMATIC_REPORT_SUCCESS = "AUTOMATIC_REPORT_SUCCESS";
export const AUTOMATIC_REPORT_FAILURE = "AUTOMATIC_REPORT_FAILURE";
export const AUTOMATIC_REPORT_RESET = "AUTOMATIC_REPORT_RESET";



